import { useEffect, useState } from 'react';

export default (events, config) => {
    const [callEvent, setCallEvent] = useState(null);

	if (!config?.id) {
		return callEvent;
	}

    useEffect(() => {
		const callEventName = `mqtt:u/${config.id}/meetings/created`
		const callUpdateEventName = `mqtt:u/${config.id}/meetings/updated`;
		const callEndedEventName = `mqtt:u/${config.id}/meetings/ended`;
		const callPushEventName = 'meetings:new';
		const callFromWorkflow = 'meetings:workflow:start';

		events.listen(callEventName, (meeting) => {
			setCallEvent({ name: "callStartPush", meeting });
		});

		events.listen(callPushEventName, (meeting) => {
			setCallEvent({ name: "callStartEvent", meeting });
		});

		events.listen(callUpdateEventName, meeting => {
			setCallEvent({ name: "callUpdateEvent", meeting });
		});

		events.listen(callEndedEventName, (meeting) => {
			setCallEvent({ name: "callEndedEvent", meeting });
		});

		events.listen(callFromWorkflow, (data) => {
			setCallEvent({ name: "callFromWorkflow", who: data.who });
		});

		return () => {
			setCallEvent(null);
		};
	}, [config.id, events.listen]);
	return callEvent;
};
